"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PieceAssetBuilder = exports.PieceAsset = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var PieceAsset = /** @class */ (function () {
    function PieceAsset() {
    }
    PieceAsset.getPieces = function (pieceAssets) {
        return pieceAssets.map(function (asset) { return asset.piece; });
    };
    return PieceAsset;
}());
exports.PieceAsset = PieceAsset;
var PieceAssetBuilder = /** @class */ (function () {
    function PieceAssetBuilder(pieceAsset) {
        this.pieceAsset = pieceAsset;
    }
    PieceAssetBuilder.initialiseWithPieceAsset = function (pieceAsset) {
        return new PieceAssetBuilder(pieceAsset);
    };
    PieceAssetBuilder.initialise = function (ownerPartyId, sharedWithEveryone, piece) {
        return PieceAssetBuilder.initialiseWithPieceAsset({
            id: piece.id,
            ownerPartyId: ownerPartyId,
            public: sharedWithEveryone,
            piece: piece,
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    PieceAssetBuilder.prototype.build = function () {
        return this.pieceAsset;
    };
    PieceAssetBuilder.prototype.buildUpdate = function () {
        return {
            ownerPartyId: this.pieceAsset.ownerPartyId,
            public: this.pieceAsset.public,
            piece: this.pieceAsset.piece
        };
    };
    PieceAssetBuilder.prototype.getId = function () {
        return this.pieceAsset.id;
    };
    PieceAssetBuilder.prototype.withId = function (id) {
        this.pieceAsset.id = id;
        this.pieceAsset.piece.id = id;
        return this;
    };
    PieceAssetBuilder.prototype.withPieceUpdate = function (pieceUpdate) {
        this.pieceAsset = {
            id: this.pieceAsset.id,
            ownerPartyId: this.pieceAsset.ownerPartyId,
            public: this.pieceAsset.public,
            piece: __assign(__assign({}, this.pieceAsset.piece), pieceUpdate),
            createdAt: this.pieceAsset.createdAt,
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        };
        return this;
    };
    return PieceAssetBuilder;
}());
exports.PieceAssetBuilder = PieceAssetBuilder;
